import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "p-datatable" }
const _hoisted_3 = { class: "p-datatable-wrapper" }
const _hoisted_4 = { class: "p-datatable-table" }
const _hoisted_5 = { class: "p-datatable-thead" }
const _hoisted_6 = ["index", "onClick"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "p-datatable-tbody" }
const _hoisted_9 = ["index"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["index", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('schedule_by_days')), 1),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default"),
      (!_ctx.hideSchedule)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("table", _hoisted_4, [
                  _createElementVNode("thead", _hoisted_5, [
                    _createElementVNode("tr", null, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (thIndex) => {
                        return _createElementVNode("th", {
                          class: "cursor-pointer",
                          index: thIndex,
                          onClick: ($event: any) => (_ctx.selectDays(thIndex - 1))
                        }, [
                          (thIndex > 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.days[thIndex - 2]), 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_6)
                      }), 64))
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_8, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (trIndex) => {
                      return _createElementVNode("tr", { index: trIndex }, [
                        _createElementVNode("td", {
                          class: "cursor-pointer",
                          onClick: ($event: any) => (_ctx.selectHours(trIndex - 1))
                        }, _toDisplayString((trIndex - 1).toString().padStart(2, '0')) + ":00", 9, _hoisted_10),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (tdIndex) => {
                          return _createElementVNode("td", {
                            class: "cursor-pointer",
                            index: tdIndex,
                            onClick: ($event: any) => (_ctx.select(tdIndex, trIndex - 1))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["pi", { 'pi-circle': !_ctx.inSchedule(tdIndex, trIndex - 1), 'pi-circle-fill text-blue-600': _ctx.inSchedule(tdIndex, trIndex - 1), 'text-pink-600': !_ctx.schedule.length }])
                            }, null, 2)
                          ], 8, _hoisted_11)
                        }), 64))
                      ], 8, _hoisted_9)
                    }), 64))
                  ])
                ])
              ])
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mt-2" }, "Time targeting is set due to the time zone of the geo campaign is set on", -1))
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 64))
}